import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
  Stack,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React from "react";
import ChatHeaderActions from "./components/ChatHeaderActions";

const ChatSearchHeader = ({ onAddChat }) => {
  return (
    <Stack px={2} pt={2} spacing={2}>
      {/* Top section: Chats label and add button */}
      <ChatHeaderActions onAddChat={onAddChat} />

      {/* Search input */}
      <TextField
        fullWidth
        placeholder="Search a chat"
        variant="outlined"
        size="small"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon sx={{ fontSize: 18, color: "#666" }} />
            </InputAdornment>
          ),
          sx: {
            borderRadius: "999px",
            height: 40,
            px: 1.5,
            bgcolor: "#f5f5f5",
            fontSize: 14,
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "999px",
            borderColor: "#e0e0e0",
            "& fieldset": {
              border: "1px solid #e0e0e0",
            },
            "&:hover fieldset": {
              borderColor: "#cfcfcf",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#999",
            },
          },
        }}
      />
    </Stack>
  );
};

export default ChatSearchHeader;
